import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const tableRowVariants = tv({
  base: "transition-colors duration-100 [&:last-child>td]:border-b-0 [&>td]:border-b [&>td]:border-line",
});

export const TableRow = ({ className, ...props }: ComponentProps<"tr">) => {
  return <tr className={tableRowVariants({ className })} {...props} />;
};
